var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallEnd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 82,
    viewBox: "0 0 94 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 79.1521,
    height: 67.1319,
    rx: 33.566,
    fill: "#DC362E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3.5,
    width: 86.1521,
    height: 74.1319,
    rx: 37.066,
    stroke: "#DC362E",
    strokeOpacity: 0.15,
    strokeWidth: 7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_250_206)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_250_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4328 47.1669L24.8147 43.5488C24.4775 43.2143 24.2138 42.813 24.0406 42.3707C23.8674 41.9284 23.7885 41.4548 23.8089 40.9802C23.8294 40.5056 23.9487 40.0406 24.1593 39.6148C24.3698 39.189 24.667 38.8119 25.0318 38.5076C29.1462 35.1997 33.9791 32.903 39.1423 31.8021C43.9079 30.7398 48.849 30.7398 53.6146 31.8021C58.7991 32.9102 63.6496 35.2239 67.7733 38.5558C68.137 38.8592 68.4334 39.235 68.6439 39.6592C68.8544 40.0834 68.9742 40.5468 68.9958 41.0199C69.0173 41.493 68.9401 41.9654 68.7691 42.407C68.5981 42.8486 68.337 43.2498 68.0025 43.585L64.3844 47.203C63.8049 47.7941 63.0302 48.1542 62.2047 48.2164C61.3793 48.2785 60.5594 48.0384 59.898 47.5407C58.5874 46.5356 57.1673 45.6819 55.6648 44.996C55.0709 44.7266 54.5666 44.2926 54.2118 43.7454C53.857 43.1982 53.6665 42.5607 53.6628 41.9086V38.8453C48.9266 37.5428 43.9267 37.5428 39.1905 38.8453L39.1905 41.9086C39.1869 42.5607 38.9963 43.1982 38.6415 43.7454C38.2867 44.2926 37.7824 44.7266 37.1885 44.996C35.686 45.6819 34.2659 46.5356 32.9554 47.5407C32.2869 48.0439 31.4568 48.2839 30.6229 48.2149C29.789 48.146 29.0096 47.773 28.4328 47.1669Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_206"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.8823,
    y: 40.9412,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(135 80.8823 40.9412)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_250_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.9338,
    height: 40.9338,
    fill: "white",
    transform: "translate(75.3713 41.0403) rotate(135)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallEnd);
export default __webpack_public_path__ + "static/media/callEnd.98e0678a0fb6f744227651627a26f5bd.svg";
export { ForwardRef as ReactComponent };